import { Text } from "@mantine/core";
import React from "react";

function SectionHeading({ children }: { children: React.ReactNode }) {
  return (
    <Text
      mb="xs"
      mt="md"
      className="text-sm font-semibold"
      color="dimmed"
      component="h2"
    >
      {children}
    </Text>
  );
}

export default SectionHeading;
